import styled from "styled-components";
import theme from "../../theme";

const WrapperMyData = styled.div`
    margin: 30px 13%;
    display: flex;
    justify-content: center;
    position: relative;
 
    .container-a{
        display: flex;
        flex-direction: column;
        gap: 20px;
        width: 40%;
        margin-left: 50px;
        margin-top: 50px;
        height: 60vh;
        overflow: auto;

        &.pac-item.pac-item-selected .pac-logo {
            display: none !important;
        }
        &::-webkit-scrollbar {
            width: 10px; 
        }

        &::-webkit-scrollbar-track {
            background: #f1f1f1;
        }

        &::-webkit-scrollbar-thumb {
            background: #888; 
            border-radius: 5px; 
        }

        .header {
            display: flex;
            align-items: center;
            gap: 5px;

            svg {
                font-size: 2.2rem;
            }

            font-size: 1rem;

            &.address{
                margin-top: 20px;
            }
        }

        .line {
            display: flex;
            flex-direction: column;
            gap: 4px;
            width: 99%;

            .feedback {
                font-size: .8rem;
                color: red;
                margin-left: 20px;
                font-family: ${theme.fontFamily.medium};
            }

            .title {
                font-size: 1rem;
                font-weight: 600;
                margin-left: 25px;
            }

            input {
                outline: none;
                border: 2px solid #bcbcbc;
                font-size: .915rem;
                padding: 8px 25px;
                width: calc(100% - 54px);
                border-radius: 100px;

                &[disabled] {
                    background-color: #bcbcbc;
                }
            }
        }

        .button {
            margin-top: 20px;
            background-color: ${theme.fontColor.green};
            align-self: flex-start;
            padding: 2px 30px;
            border-radius: 100px;
            font-size: 1.1rem;
            color: white;
            cursor: pointer;

            &.deactived {
                background-color: #888;
            }
        }

        .actions {
            display: flex;
            align-items: center;
            gap: 10px;
            margin-bottom: 10px;

            .button:nth-child(2){
                background-color: white;
                color: black;
                padding: 0;
                font-size: .9rem;
            }
        }

        .open-menu {
            display: none;
        }
    }

    .container-b{
        display: flex;
        flex-direction: column;
        gap: 7px;
        width: 55%;
        margin-left: 50px;
        margin-top: 50px;
        height: 60vh;

        .plan {
            font-size: 3rem;
            font-weight: 600;
            color: #01bbb6;
            font-family: ${theme.fontFamily.bold};
        }

        .line {
            display: flex;
            align-items: center;
            gap: 15px;
            margin-bottom: 10px;

            img {
                width: 25px;
            }

            &:nth-child(6) {
                margin-top: 30px;
                justify-content: flex-start;
                align-items: flex-start;
                font-weight: 600;
                color: rgb(60 ,60 ,60 );

                .bold {
                    margin-left: -7px;
                    font-weight: 600;
                    color: #01bbb6;
                }
            }
        }

        .button {
            margin-top: 30px;
            padding: 6px 40px;
            border-radius: 100px;
            font-size: .875rem;
            background-color: #01bbb6;
            align-self: flex-start;
            color: white;
            font-weight: 600;
        }
    }

    .container-c{
        display: flex;
        flex-direction: column;
        width: 55%; 
        gap: 20px;
        margin-left: 50px;
        overflow-y: auto;
        margin-top: 40px;
        height: 60vh;
        ${({ nothing }) => (nothing ? 'justify-content: center;' : '')}
        ${({ nothing }) => (nothing ? 'align-items: center;' : '')}

        &::-webkit-scrollbar {
            width: 10px;
        }

        &::-webkit-scrollbar-track {
            background: #f1f1f1;
        }

        &::-webkit-scrollbar-thumb {
            background: #888;
            border-radius: 5px;
        }

        .nothing {
            font-size: 1.1rem;
        }

        .search-box {
            width: 90%;
            display: flex;
            flex-direction: column;
            gap: 2px;

            .title {
                font-size: 1.1rem;
                font-weight: 600;
                margin-left: 20px;
            }

            input {
                outline: none;
                border: #888 1px solid;
                border-radius: 100px;
                padding: 7px 20px;
                font-size: 1.05rem;
            }
        }

        .properties {
            display: flex;
            flex-direction: column;
            gap: 10px;
        }
        
    }

    .container-favorites{
        display: flex;
        flex-direction: column;
        width: 55%; 
        gap: 20px;
        margin-left: 50px;
        overflow-y: auto;
        margin-top: 40px;
        height: 60vh;
        ${({ nothing }) => (nothing ? 'justify-content: center;' : '')}
        ${({ nothing }) => (nothing ? 'align-items: center;' : '')}

        .nothing-favorites {
            font-size: 1.1rem;
        }

        &::-webkit-scrollbar {
            width: 10px;
        }

        &::-webkit-scrollbar-track {
            background: #f1f1f1;
        }

        &::-webkit-scrollbar-thumb {
            background: #888;
            border-radius: 5px;
        }

        .search-box {
            width: 90%;
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            gap: 2px;

            .title {
                width: calc(20% - 20px);
                font-size: 1.1rem;
                font-weight: 600;
                margin-left: 20px;
            }

            .clear-history{
                width: calc(20% - 20px);
                font-size: .9rem;
                font-weight: 600;
                text-align: end;
                transform: translateY(5px);
                margin-right: 20px;
                cursor: pointer;
            }

            input {
                outline: none;
                border: #888 1px solid;
                border-radius: 100px;
                padding: 7px 20px;
                width: calc(100% - 42px);
                font-size: 1.05rem;
            }
        }

        .properties {
            display: flex;
            flex-direction: column;
            gap: 30px;
            width: 99%;
        }

        .pagination {
            display: flex;
            align-items: center;
            justify-content: end;
            margin-right: 40px;
            gap: 10px;

            button {
                padding: 17px;
                border-radius: 15px;
                border: 2px solid #dce0e1;
                display: flex;
                align-items: center;
                justify-content: center;
                transition: background-color 0.3s ease; 
                cursor: pointer;
                user-select: none;

                svg {
                    color: ${theme.fontColor.green};
                    transition: color 0.3s ease;
                    font-size: .8rem;
                }

                &:hover {
                    background-color: ${theme.fontColor.green};
                    
                    svg {
                        color: #dce0e1;
                    }
                }

                &:disabled {
                    background-color: #dce0e1;
                    
                    svg {
                        color: #888;
                    }
                }
            }
        }
        
    }

    .container-d{
        display: flex;
        flex-direction: column;
        gap: 20px;
        width: 55%; 
        margin-left: 50px;
        margin-top: 20px;
        overflow-x: auto;
        height: 60vh;
        
        &::-webkit-scrollbar {
            width: 10px;
        }

        &::-webkit-scrollbar-track {
            background: #f1f1f1;
        }

        &::-webkit-scrollbar-thumb {
            background: #888;
            border-radius: 5px;
        }
        .title {
            font-size: 2rem;
            font-family:  ${theme.fontFamily.bold}
        }

        .body {
            font-size: .955rem;
        }
    }

    .container-change-password{
        display: flex;
        flex-direction: column;
        width: 40%; 
        gap: 13px;
        margin-left: 50px;
        margin-top: 50px;
        height: 60vh;

        .line {
            display: flex;
            flex-direction: column;
            gap: 0px;
            width: 100%;

            .title {
                font-size: 1.1rem;
                margin-left: 10px;
                font-family:  ${theme.fontFamily.regular};
                color: #171717;
            }

            .input-box{
                display: flex;
                border-radius: 100px;
                justify-content: space-between;
                width: 95%;
                padding: 5px 2.5%;
                background-color: #e4e4e4;

                input{
                    width: 88%;
                    border: none;
                    outline: none;
                    background-color: rgba(0,0,0,0);
                    font-size: .915rem;
                }

                .sufix {
                    font-family:  ${theme.fontFamily.regular};
                    user-select: none;
                    cursor: pointer;
                }
            }
        }

        .button {
            margin-top: 20px;
            background-color: ${theme.fontColor.green};
            align-self: flex-start;
            padding: 2px 30px;
            border-radius: 100px;
            font-size: 1.1rem;
            color: white;
            cursor: pointer;
        }
    }

    .container-f{
        display: flex;
        flex-direction: column;
        gap: 20px;
        width: 55%; 
        margin-left: 50px;
        margin-top: 20px;
        overflow-x: auto;
        height: 60vh;

        &::-webkit-scrollbar {
            width: 10px;
        }

        &::-webkit-scrollbar-track {
            background: #f1f1f1;
        }

        &::-webkit-scrollbar-thumb {
            background: #888;
            border-radius: 5px;
        }

        .title {
            font-size: 2rem;
            font-family:  ${theme.fontFamily.bold}
        }

        .body {
            font-size: .955rem;
        }
    }

    .container-chats, .notifications{
        display: flex;
        flex-direction: column;
        width: 40%;     
        margin-left: 50px;
        gap: 10px;
        overflow: auto;
        overflow-x: hidden;
        height: calc(60vh + 50px);
        ${({ nothing }) => (nothing ? 'justify-content: center;' : '')}
        ${({ nothing }) => (nothing ? 'align-items: center;' : '')}
        
        .nothing-chat, .nothing {
            font-size: 1.2rem;
        }

        &::-webkit-scrollbar {
            width: 10px; 
        }

        &::-webkit-scrollbar-track {
            background: #f1f1f1;
        }

        &::-webkit-scrollbar-thumb {
            background: #888; 
            border-radius: 5px; 
        }
    }

    .container-chat {
        display: flex;
        flex-direction: column;
        width: 55%; 
        gap: 20px;
        margin-left: 50px;
        margin-top: 50px;
        position: relative;
        height: 60vh;

        .main {
            width: 70%;
            border-radius: 17px;
            position: relative;
            margin-top: -20px;

            .back {
                position: absolute;
                margin-top: -20px;
                cursor: pointer;
            }


            .header-chat {
                background-color: #e5fffe;
                display: flex;
                align-items: center;
                gap: 10px;
                border: 1px solid gray;
                border-radius: 17px;
                padding: 5px 0px;
                flex-wrap: wrap;
                transform: translateY(15px);
                

                img {
                    margin-left: 20px;
                    border-radius: 100px;
                    border: 2px solid white;
                    width: 60px;
                    height: 60px;
                }

                .username {
                    font-size: 1.2rem;
                    font-weight: 600;
                }
            }

            .body-chat {
                background-color: #e5fffe;
                overflow: auto;
                display: flex;
                flex-direction: column;
                gap: 10px;
                height: 50vh;
                overflow-y: visible;
                border: 1px solid gray;
                border-top: none;
                border-bottom: none;

                &::-webkit-scrollbar {
                    width: 10px; 
                }

                &::-webkit-scrollbar-track {
                    background: #f1f1f1;
                }

                &::-webkit-scrollbar-thumb {
                    background: #888; 
                    border-radius: 5px; 
                }

                .space {
                    height: 40px;
                }

                .message {
                    width: 90%;
                    margin-bottom: 10px;
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                    margin: 0 auto;
                    padding-bottom: 10px;

                    span {
                        width: 80%;
                    }

                    .username {
                        font-size: 1rem;
                        font-weight: 600;
                    }

                    .moment{
                        font-size: .7rem;
                    }

                    &.received {
                        width: 80%;
                        margin-left: 5%;
                        margin-right: 15%;
                    }

                    &.sended{
                        width: 80%;
                        margin-left: 15%;
                        margin-right: 5%;
                        align-self: flex-end;
                        display: flex; 
                        text-align: end;

                        span {
                            width: 100%;
                            text-align: end;
                        }
                    }
                }
            }

            .inputbox {
                border: 1px solid gray;
                border-top: none;
                border-bottom-left-radius: 17px;
                border-bottom-right-radius: 17px;
                background-color: #e5fffe;


                .input-container {
                    transform: translateY(-5px);
                    border-radius: 100px;
                    width: 95%;
                    margin: 0 auto;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    background-color: white;
                    border: 1px solid gray;
                    padding: 4px 0px;

                    input {
                        width: calc(80%);
                        border-radius: 100px;
                        border: none;
                        outline: none;
                        padding: 2px 12px;
                        font-size: 1.15rem;
                    }

                    svg {
                        margin-right: 12px;
                    }
                }
            }

            
        }
    }


    @media (max-width: ${theme.breackpoint.mobile_2}) {
        margin: 30px 5%;
        height: 75vh;
        

        .container-a, .container-b,
        .container-c, .container-d,
        .container-change-password, 
        .container-f, .container-chats, .notifications,
        .container-chat {
            width: 100%;
            margin-left: 0;
            position: relative;
        }

        .container-a {
            height: 100%;
            margin-top: -20px;

            .actions {
                justify-content: flex-end;
                margin-right: 5px;

                .button {
                    padding: 5px 30px;
                }
            }
        }

        .container-chat {
            margin: 0;
            height: 100%;

            .back {
                display: none;
            }

            
        }


        .container-c {
            margin: 0;
            margin-bottom: 70px;
        }


        .container-f, .container-d, .container-c, .container-favorites{
            height: 100%;
            width: 100%;
        }
        .container-favorites{
            margin: 0;
            margin-bottom: 50px;
        }
        .container-chat {
            .main {
                width: 100%;
            }
        }
    }
    
    @media (max-width: ${theme.breackpoint.tabletsAndSmallScreens}) and (min-width: ${theme.breackpoint.mobile_2}) {
        margin: 30px 2%;

        .container-a, .container-b,
        .container-c, .container-d,
        .container-change-password, .container-f {
            width: 50%;
        }
    }
    
    @media (max-width: ${theme.breackpoint.commonScreensAndLaptops}) and (min-width: ${theme.breackpoint.tabletsAndSmallScreens}) {
        margin: 30px 8%;

        .container-a, .container-b,
        .container-c, .container-d,
        .container-change-password, .container-f {
            width: 50%;
        }
    }
    
    @media (max-width: ${theme.breackpoint.largeScreens}) and (min-width: ${theme.breackpoint.commonScreensAndLaptops}) {
        margin: 30px 8%;

        .container-a, .container-b,
        .container-c, .container-d,
        .container-change-password, .container-f {
            width: 50%;
        }
    }
    
    @media (max-width: ${theme.breackpoint.bigScreens}) and (min-width: ${theme.breackpoint.largeScreens}) {
        
    }
    
`

export default WrapperMyData